module.exports = __webpack_public_path__ + "img/checkin_step3.5eccc212.jpg";